/**
 * Income redirect
 */
export const incomeRedirect = () => {
  const PATH = userPath();
  const employmentType = getStateValue("employmentType");
  const IS = (arr: any) => arr.includes(employmentType);

  switch (PATH) {
    case USER_PATHS.ML:
      return "/residenza";
    case USER_PATHS.CQ:
      if (IS([JOB_TYPES.PENSIONATO])) return "/domanda-cessione";
      else return "/lavoro";
      return;
    case USER_PATHS.FAM:
      return "/nucleo-familiare";
    case USER_PATHS.FE:
      if (
        [
          JOB_TYPES.AUTONOMO,
          JOB_TYPES.DIPENDENTE,
          JOB_TYPES.STAGIONALE,
          JOB_TYPES.PROFESSIONISTA,
        ].includes(employmentType)
      )
        return "/lavoro";
      else if (insuranceAvailable()) return "/assicurazione";
      else return "/residenza";
      break;
  }
};

/**
 * Rata redirect
 */
export const rataRoute = ({selectUpgrade = true}): string => {
  const CREDIT = Number(getStateValue("selectedCredit"));
  if(CREDIT <= POWER_CREDIT_MAX_CREDIT && isPromoCreditSelected()) {
    return selectUpgrade ? "/rata-power-credit-upgrade" : "/rata-power-credit-default-upgrade"
  }
  if (CREDIT <= POWER_CREDIT_MAX_CREDIT) {
    return "/rata-power-credit"
  }
  return "/rata";
}

/**
 * TYP redirect
 */
export const typRoute = () => {
  const PACK: string = getStateValue("insurancePack");
  const INSURANCE: boolean = getStateValue("insurance");
  const METLIFE: boolean = INSURANCE && PACK == "Metlife";
  const SERVICE: boolean = getStateValue("service");
  const CLUBPLUS: boolean =
    SERVICE && getStateValue("servicePack") == CLUB_PLUS.code;
  const CLUB: boolean = SERVICE && getStateValue("servicePack");
  const PP = !getStateValue("isRevolving");
  const ADE = INSURANCE && PACK !== "Metlife";
  const PATH = userPath();

  switch (PATH) {
    case USER_PATHS.CQ:
      updateStateValue("envName", "cq");
      if (METLIFE) return "/typ-cq-metlife";
      else return "/typ-cq";
    case USER_PATHS.ML:
      updateStateValue("envName", "metlife");
      if (PACK === "Metlife") {
        if (INSURANCE) return "/metlife-ok";
        else return "/metlife-ko";
      } else {
        if (CLUBPLUS) return "/typ-club";
        else return "/club-ko";
      }
    case USER_PATHS.FE:
      updateStateValue("envName", isRevolving() ? "revolving" : "pp");
      if (PP) {
        if (METLIFE) return "/typ-pp-metlife";
        else if (ADE && CLUB) return "/typ-pp-ade-club";
        else if (ADE) return "/typ-pp-ade";
        else if (CLUB) return "typ-pp-club";
        else return "/typ-pp";
      } else {
        if (METLIFE) return "/typ-pc-metlife";
        else if (CLUBPLUS) return "/typ-pc-club";
        else return "/typ-pc";
      }
  }
};
